import daily from "@daily-co/daily-js";
import VideoCallAdapter from "../VideoCallAdapter";

const EVENT_MAP = {
  joining: "joining-meeting",
  joined: "joined-meeting",
  "participant-joined": "participant-joined",
  "participant-updated": "participant-updated",
  "participant-left": "participant-left",
  error: "error"
};

const CHAT_TYPE = "videomedi-chat-v1";

export default class DailyAdapter extends VideoCallAdapter {
  constructor() {
    super();
    this._callObject = null;
    this._messageHandlers = new Map();
  }

  init(options) {
    this._callObject = daily.createCallObject(options);
  }

  join(userName) {
    return this._callObject.join({ userName });
  }

  leave() {
    return this._callObject.leave();
  }

  destroy() {
    this._callObject.destroy();
    this._callObject = null;
  }

  getParticipants() {
    if (!this._callObject) return [];
    return Object.values(this._callObject.participants());
  }

  localAudio() {
    return this._callObject ? this._callObject.localAudio() : true;
  }

  localVideo() {
    return this._callObject ? this._callObject.localVideo() : true;
  }

  setLocalAudio(enabled) {
    this._callObject.setLocalAudio(enabled);
  }

  setLocalVideo(enabled) {
    this._callObject.setLocalVideo(enabled);
  }

  sendMessage(payload) {
    this._callObject.sendAppMessage({ _type: CHAT_TYPE, ...payload }, "*");
  }

  on(event, handler) {
    if (event === "message") {
      const wrapper = e => {
        if (e.data?._type === CHAT_TYPE) handler(e.data);
      };
      this._messageHandlers.set(handler, wrapper);
      this._callObject.on("app-message", wrapper);
      return;
    }
    const dailyEvent = EVENT_MAP[event];
    if (dailyEvent) this._callObject.on(dailyEvent, handler);
  }

  off(event, handler) {
    if (event === "message") {
      const wrapper = this._messageHandlers.get(handler);
      if (wrapper) {
        this._callObject.off("app-message", wrapper);
        this._messageHandlers.delete(handler);
      }
      return;
    }
    const dailyEvent = EVENT_MAP[event];
    if (dailyEvent) this._callObject.off(dailyEvent, handler);
  }
}
